// extracted by mini-css-extract-plugin
module.exports = {"productList":"OtherProducts_productList__21d5H","wrap":"OtherProducts_wrap__2VVgl"};